import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import MainLayout from "../../components/Layouts/MainLayout";
import axios from "axios";
import { useSelector } from "react-redux";
import apiClient from '../../api/apiClient';
function TaskerDashboard() {
  const navigate = useNavigate();
  const [tasksNumber, setTasksNumber] = useState(0);
  const [tasksToday, setTasksToday] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const { user, accessToken } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchTasksNumber = async () => {
      setIsLoading(true);
      try {
        const response = await apiClient.get(`/api/dashboard/tasker/`, {
          headers: {
            Authorization: `Bearer ${accessToken}`, // this header will be updated automatically by interceptor on 401
          },
        });

        setTasksNumber(response.data.total_tasks);
        setTasksToday(response.data.total_tasks_today);
      } catch (error) {
        console.error("Failed to fetch tasks data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    // Only fetch if an access token is available
    if (accessToken) fetchTasksNumber();
  }, [accessToken]);
  const handleEnrollClick = () => {
    navigate(`/tasks`);
  };

  // Time of day greeting
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  return (
    <MainLayout>
      <main className="p-4 md:ml-64 min-h-screen pt-10 bg-gradient-to-br dark:from-gray-900  dark:to-gray-800">
        <div className="max-w-7xl mx-auto sm:px-6 py-10 mb-5">
          {/* Header Section with Animated Greeting */}
          <div className="px-4 sm:px-0 mb-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between">
              <div className="mb-4 md:mb-0">
                <span className="inline-block px-3 py-1 text-sm font-medium text-emerald-800 bg-emerald-100 rounded-full dark:bg-emerald-900 dark:text-emerald-200">
                  {getGreeting()}
                </span>
                <h1 className="mt-2 text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white">
                  Hello, <span className="text-emerald-600 dark:text-emerald-400">{user?.first_name}</span>!
                </h1>
                <p className="mt-1 text-gray-600 dark:text-gray-300">
                  Here's how your Smile Project journey is going
                </p>
              </div>
       
            </div>
          </div>

          {/* Stats and Info Cards */}
          <div className="px-4 sm:px-0">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 dark:bg-gray-800 dark:border-gray-700">
              <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-lg font-bold text-gray-800 dark:text-white">Task Activity</h2>
                  {/* <span className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200">
                    Current Month
                  </span> */}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/* Total Tasks Card */}
                  <div className="bg-gradient-to-br from-cyan-50 to-emerald-50 rounded-lg p-4 dark:from-gray-700 dark:to-gray-700 relative overflow-hidden">
                    <div className="absolute right-0 top-0 w-20 h-20 opacity-10">
                      <svg className="text-emerald-600 dark:text-emerald-400 w-full h-full" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">
                      Total Tasks Submitted
                    </h3>
                    {isLoading ? (
                      <div className="animate-pulse h-8 w-16 bg-gray-200 dark:bg-gray-600 rounded"></div>
                    ) : (
                      <div className="flex items-end">
                        <span className="text-3xl font-bold text-gray-900 dark:text-white">{tasksNumber}</span>
                        <div className="ml-2 text-sm font-medium text-emerald-600 dark:text-emerald-400">
                          {/* <span className="flex items-center">
                            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
                            </svg>
                            +4%
                          </span> */}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Today's Tasks Card */}
                  <div className="bg-gradient-to-br from-cyan-50 to-emerald-50 rounded-lg p-4 dark:from-gray-700 dark:to-gray-700 relative overflow-hidden">
                    <div className="absolute right-0 top-0 w-20 h-20 opacity-10">
                      <svg className="text-cyan-600 dark:text-cyan-400 w-full h-full" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">
                      Tasks Submitted Today
                    </h3>
                    {isLoading ? (
                      <div className="animate-pulse h-8 w-16 bg-gray-200 dark:bg-gray-600 rounded"></div>
                    ) : (
                      <div className="flex items-end">
                        <span className="text-3xl font-bold text-gray-900 dark:text-white">{tasksToday}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Progress Bar */}
                {/* <div className="mt-6">
                  <div className="flex justify-between mb-1">
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300">Weekly Progress</span>
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      {Math.min(100, (tasksNumber / 20) * 100).toFixed(0)}%
                    </span>
                  </div>
                  <div className="w-full h-3 bg-gray-200 rounded-full dark:bg-gray-700 overflow-hidden">
                    <div 
                      className="h-full rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500"
                      style={{ width: `${Math.min(100, (tasksNumber / 20) * 100)}%` }}
                    ></div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* Project Feature Card - Using the same margin as the cards above */}
        <div className="px-4 sm:px-6 max-w-7xl mx-auto mb-8">
          <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 dark:bg-gray-800 dark:border-gray-700">
            <div className="md:flex">
              <div className="md:flex-shrink-0 w-full md:w-1/3 bg-gradient-to-br from-cyan-500 to-emerald-500 p-6 flex items-center justify-center relative overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                  <svg className="w-full h-full text-white" viewBox="0 0 80 80" fill="currentColor">
                    <path d="M40 0C17.9 0 0 17.9 0 40s17.9 40 40 40 40-17.9 40-40S62.1 0 40 0zm0 70c-16.5 0-30-13.5-30-30s13.5-30 30-30 30 13.5 30 30-13.5 30-30 30z"></path>
                    <path d="M52.8 40c0 7.1-5.7 12.8-12.8 12.8S27.2 47.1 27.2 40 32.9 27.2 40 27.2 52.8 32.9 52.8 40z"></path>
                  </svg>
                </div>
                <div className="text-center relative z-10">
                  <span className="text-6xl block mb-2">😊</span>
                  <h3 className="text-2xl font-bold text-white">Smile Project</h3>
              
                </div>
              </div>
              
              <div className="p-8 w-full md:w-2/3">
                <div className="flex flex-col h-full justify-between">
                  <div>
                    <div className="flex items-center mb-4">
                      <div className="flex-1">
                        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                           Smile Project
                        </h2>
                      </div>
                    </div>
                    <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                      In this exciting project, you will create prompts to train an artificially
                      intelligent (AI) assistant. Your creative contributions will directly help make 
                      AI systems more helpful, harmless, and honest.
                    </p>
                    

                  </div>
                  
                  <div className="mt-8 flex flex-col sm:flex-row gap-4">
                    <button
                      onClick={handleEnrollClick}
                      className="flex-1 inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-gradient-to-r from-cyan-500 to-emerald-500 hover:from-cyan-600 hover:to-emerald-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 transition-all duration-200"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                      </svg>
                      Start Tasking Now
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </MainLayout>
  );
}

export default TaskerDashboard;